import { render, staticRenderFns } from "./ListadoInstituciones.vue?vue&type=template&id=50cf4b7e"
import script from "./ListadoInstituciones.vue?vue&type=script&lang=js"
export * from "./ListadoInstituciones.vue?vue&type=script&lang=js"
import style0 from "./ListadoInstituciones.vue?vue&type=style&index=0&id=50cf4b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports